import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useSelectRecommendation } = getCRUDHooks({
  entityName: 'selectRecommendation',
  create: (
    values: { selectedPathId: number; selectedProgram: string },
    { studentApplicationId }: { studentApplicationId: string }
  ) =>
    clientApi
      .getOCClient()
      .helpers.studentApplication.studentApplication.id(studentApplicationId)
      .selectRecommendation.create(values),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useSelectRecommendation,
};
